import {Inject, Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {plainToClass} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {CModule} from 'shared/models/cmodules/cmodule';
import {CModuleType} from 'shared/models/cmodules/cmodule-type';
import {CModuleTypeFactoryService} from 'shared/cmodules/services/cmodule-type-factory.service';
import {CModulesOverviewHttpRepository} from '../repositories/cmodules-overview.repository.http';
import {ICModulesOverviewRepository} from '../repositories/cmodules-overview.repository.interface';

@Injectable()
export class CModulesOverviewService {

  constructor(@Inject('ICModulesOverviewRepository') private cmodulesOverviewRepository: CModulesOverviewHttpRepository) { }

  public getCModules(): Observable<Array<CModule>> {
    return this.cmodulesOverviewRepository.getCModules();
  }

  public deleteCModule(id: string): Observable<void> {
    return this.cmodulesOverviewRepository.deleteCModule(id);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-overview/services/cmodules-overview.service.ts